import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { ActivateKivraRequest } from 'src/modules/admin/invoice/models/activateKivraRequest';
import { setPagingParams } from 'src/shared/functions/createPagingParams';
import { KivraTenantResponse } from 'src/modules/admin/invoice/models/kivraTenantResponse';
import { InvoiceGroup } from '../models/invoiceGroup/invoiceGroup';
import { InvoiceGroupAccount } from '../models/invoiceGroup/invoiceGroupAccount';

const controller = 'InvoiceGroup';

export const getAllInvoiceGroups = (pageIndex, pageSize, sortCol, sortDir, filter) => {
  let endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  endpoint += filter ? `&filter=${filter}` : '';
  return AxiosInstance.get<PagedResult<InvoiceGroup>>(endpoint);
};

export const getInvoiceGroupById = (ownerId: number) => {
  return AxiosInstance.get<InvoiceGroup>(`${controller}/${ownerId}`);
};
export const getInvoiceGroupAccountsById = (ownerId: number) => {
  return AxiosInstance.get<InvoiceGroupAccount[]>(`${controller}/${ownerId}/Account`);
};
export const updateInvoiceGroupAccounts = (data: InvoiceGroupAccount) => {
  return AxiosInstance.put(`${controller}/Account`, data);
};
export const createInvoiceGroupAccounts = (data: InvoiceGroupAccount) => {
  return AxiosInstance.post(`${controller}/Account`, data);
};

export const activateKivra = (invoiceGroupId: number, data: ActivateKivraRequest) => {
  return AxiosInstance.put(`${controller}/${invoiceGroupId}/ActivateKivra`, data);
};

export const getKivra = (invoiceGroupId: number) => {
  return AxiosInstance.get<KivraTenantResponse>(`${controller}/${invoiceGroupId}/GetKivra`);
};

export const updateInvoiceGroup = (data: InvoiceGroup) => {
  return AxiosInstance.put(`${controller}`, data);
};
